<div class="asset-card" [class.expanded]="expanded" [class.expandable]="isExpandable">
  <div
    class="asset-row"
    [attr.role]="isExpandable ? 'button' : null"
    [attr.tabindex]="isExpandable || asset.entries[0].riskDistribution?.length ? 0 : null"
    [attr.aria-expanded]="isExpandable ? expanded : null"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="$event.preventDefault(); toggle()"
    (mouseenter)="!isExpandable && showRisk(asset.entries[0], $event)"
    (mouseleave)="!isExpandable && hideRisk()"
    (focus)="!isExpandable && showRisk(asset.entries[0], $event)"
    (blur)="!isExpandable && hideRisk()"
  >
    <app-currency-icon [iconKey]="asset.iconKey" [label]="asset.asset" [size]="29" />
    <span class="asset-ticker">{{ asset.asset }}</span>
    @if (asset.name) {
      <span class="asset-name">({{ asset.name }})</span>
    }

    @if (asset.total | splitParts: asset.precision; as parts) {
      <span class="asset-total olv-figure">
        <span class="amount-int">{{ parts.integer }}</span>
        @if (parts.decimal) {
          <span class="amount-decimal">{{ parts.decimal }}</span>
        }
      </span>
    }

    @if (isExpandable) {
      <mat-icon class="chevron">expand_more</mat-icon>
    }
  </div>

  @if (expanded && isExpandable) {
    <div class="asset-entries">
      @for (entry of asset.entries; track entry.currencyId) {
        <div
          class="asset-entry"
          [attr.tabindex]="entry.riskDistribution?.length ? 0 : null"
          (mouseenter)="showRisk(entry, $event)"
          (mouseleave)="hideRisk()"
          (focus)="showRisk(entry, $event)"
          (blur)="hideRisk()"
        >
          <app-currency-icon
            [iconKey]="entry.iconKey"
            [networkIconKey]="entry.networkIconKey"
            [label]="entry.label"
            [size]="16"
          />
          <div class="entry-details">
            <span class="entry-label">{{ entry.label }}</span>
            @if (entry.totalAmountInCurrency | splitParts: entry.currencyDisplayPrecision; as parts) {
              <span class="entry-amount olv-figure">
                <span class="amount-int">{{ parts.integer }}</span>
                @if (parts.decimal) {
                  <span class="amount-decimal">{{ parts.decimal }}</span>
                }
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

@if (hoveredEntry) {
  <div
    class="risk-popup"
    #riskPopup
    [style.left.px]="popupLeft"
    (mouseenter)="keepRiskOpen()"
    (mouseleave)="hideRisk()"
  >
    <app-risk-distribution-tooltip [currency]="hoveredEntry" [compact]="true" />
  </div>
}
